import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { assetsConst } from 'src/app/core/const/assets.const';

@Component({
  selector: 'megastore-nodatafound',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './noDataFound.component.html',
  styleUrls: ['./noDataFound.component.scss']
})
export class NoDataFoundComponent {
  private _type = '';

  @Input()
  set type(value: string) {
    this._type = value;
  }

  get type(): string {
    return this._type;
  }

  assetConst = assetsConst;

  getTranslationKey(type: string): string {
    switch (type) {
    case 'bag':
      return 'noItemInbag';
    case 'order':
      return 'noOrder';
    case 'wishlist':
      return 'wishlistEmpty';
    case 'search':
      return 'nosearch';
    case 'noProducts':
      return 'noProducts';
    default:
      return 'NoDataFound';
    }
  }

  fetchImage(): string {
    let image = '';
    switch (this.type) {
    case 'wishlist':
      image = this.assetConst.wishListIcon;
      break;
    case 'category':
      image = this.assetConst.categoryIcon;
      break;
    case 'bag':
    case 'search':
    case 'noProducts':
    case 'order':
      image = this.assetConst.noItemInbagIcon;
      break;
    default:
      break;
    }
    return image;
  }
}
